import PropTypes from 'prop-types'
import styled from 'styled-components'

export const NavigationV2 = styled.div`
  height: 116px;
  font-family: 'Open Sans', sans-serif;
  position: relative;
  justify-content: center;
  text-decoration: none;
  background-color: #bee81e;
  display: grid;
  grid-template-columns: clamp(2rem, 190px, 250px) minmax(768px, 1240px);
  grid-template-rows: repeat(2, var(--header-height));

  .upper-navbar {
    margin-bottom: 0;
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    display: flex;
    align-items: center;

    .navbar-nav > li > a {
      font-size: 14px;
      color: #000;
      font-weight: 700;
      letter-spacing: 0.75px;
      line-height: 24px;
      padding: 0.45rem 0.5rem 0.1rem 0.5rem;
    }
    .container {
      display: flex;
      justify-content: space-between;
      ul {
        flex: 1 1 50%;
        display: flex;
        justify-content: flex-start;
        .text a:hover {
          opacity: 0.55;
          border-bottom: 1px solid #000;
        }
      }
      ul:nth-child(2) {
        justify-content: flex-end;
        a {
          font-weight: 700;
        }
      }
      ul li a {
        font-size: 10px;
        text-transform: none;
        letter-spacing: 0.25px;
        line-height: 18px;
        font-weight: 400;
      }
      .switches a:hover {
        opacity: 0.55;
        span:nth-child(2) {
          border-bottom: 1px solid #000;
        }
      }
    }
  }
  .lower-navbar {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    display: flex;
    align-items: center;
    .navbar-nav {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    &:before,
    .container:before,
    .container:after,
    .navbar-nav:before,
    .navbar-nav:after,
    .navbar-collapse:before,
    .navbar-collapse:after {
      content: none;
    }
    .navbar-nav > li {
      white-space: nowrap;
    }
    .navbar-nav > li > a {
      font-size: 14px;
      color: #000;
      font-weight: 700;
      letter-spacing: 0.75px;
      text-transform: uppercase;
      line-height: 24px;
      padding: 0.45rem 0.5rem 0.1rem 0.5rem;
    }
    .navbar-nav > li > a:after {
      content: '';
      display: block;
      height: 5px;
      border-radius: 2.5px;
      background: black;
      position: absolute;
      transform-origin: left;
      top: 43px;
      left: 0;
      right: 0;
      transform: scale(0, 1);
      transition: transform ease-in-out 250ms;
    }
    .navbar-nav > li > a:hover::after,
    .navbar-nav > li > a:focus::after,
    .navbar-nav > li > a:active::after {
      transform: scale(1, 1);
    }
  }
  .container {
    width: 100%;
    padding: 0;
  }
  .navbar {
    border-radius: 0px;
    background-color: #bee81e;
    position: unset;
    margin: 0;
  }
  .navbar-default {
    border: none;
    margin-right: 37px;
  }
  .navbar-collapse {
    padding: 0;
  }
  .dropdown {
    position: unset;
  }
  .dropdown-menu {
    background: #f2f2f2;
    width: clamp(994px, 90vw, 1240px);
    left: 5vw;
    min-height: 380px;
    z-index: 1000;
    padding: 60px 60px 20px 60px;
  }
  .navbar-default .navbar-nav > .open > a {
    background-color: rgb(204, 255, 0);
    color: #000;
  }
  .title {
    flex: 1;
    h2 {
      font-size: 44px;
      font-weight: 700;
      letter-spacing: -0.5px;
      line-height: 46px;
    }
    p {
      color: #b2b2b2;
      line-height: 18px;
      font-size: 14px;
    }
  }
  #brand {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    display: flex;
    justify-content: flex-end;
    margin-right: 24px;
    margin-left: auto;
    max-height: 116px;
    max-width: 111px;
    cursor: pointer;
  }
  .open > .dropdown-menu {
    display: flex;
    & > div {
      padding: 0 15px;
      white-space: pre-wrap;
    }
    .menu {
      flex: 3;
      justify-content: space-between;
      align-items: flex-start;
      display: flex;
      li {
        flex: 1 1 25%;
      }
    }
    .animated {
      animation-duration: 1s;
      animation-fill-mode: both;
    }
  }
  @media (max-width: 991px) {
    display: unset !important;

    .lower-navbar .navbar-nav > li > a:after {
      height: 0;
    }
    .navbar-header {
      background-color: #bee81e;
      height: var(--header-height);
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 0;
      align-items: center;
    }
    .navbar-default {
      margin-right: 0;
    }
    .navbar-header > * {
      flex: 1;
    }
    .navbar-left,
    .navbar-right {
      float: none !important;
    }
    .navbar-toggle {
      display: block;
      border: none;
    }
    .navbar-collapse {
      background-color: #fff;
      border-top: 1px solid transparent;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }
    .navbar-fixed-top {
      top: 0;
      border-width: 0 0 1px;
    }
    .navbar-collapse.collapse {
      display: none !important;
    }
    .navbar-default .navbar-toggle:focus,
    .navbar-default .navbar-toggle:hover {
      background-color: transparent;
    }
    .navbar-nav {
      margin: 0;
      float: none !important;
    }
    .navbar-nav > li {
      float: none;
      position: relative;
    }
    .navbar-nav > li > a {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .collapse.in {
      display: block !important;
    }
    .container > .navbar-collapse {
      margin: 0;
    }
    .navbar-default .navbar-toggle .icon-bar {
      background-color: #000;
    }
    .open > .dropdown-menu,
    .open > .dropdown-menu .menu,
    .lower-navbar .navbar-nav {
      display: unset;
    }
    .open > .dropdown-toggle img {
      transform: rotate(180deg);
    }
    .navbar-default .navbar-nav > .open > a {
      color: #000;
      background-color: rgb(204, 255, 0);
    }
    .text {
      padding: 20px 20px 20px 1rem;
    }
    .dropdown {
      background-color: #fff;
      margin: 0 0 0 1rem;
      padding: 0;
      margin-left: 0;
      margin-right: 0;
      a {
        border-bottom: 0;
        margin-left: 0;
        padding: 20px 20px 20px 0 !important;
      }
    }
    .dropdown-menu {
      padding: 20px;
    }
    .small-text {
      font-size: 11px;
      text-transform: none;
    }
    .border {
      border-bottom: 1px solid #d8d8d8;
    }
    .search {
      form {
        border-bottom: 1px solid #d8d8d8;
        padding: 0;
        width: 100%;
        line-height: 0;
      }
      .input-group {
        display: flex;
        width: 100%;
        height: var(--button-height);
        position: relative;
        margin-top: 0;
        margin-bottom: 0;
      }
      .form-control {
        border: none;
        background: var(--grey-0);
      }
      .input-group-addon {
        width: 50px;
        background-color: var(--clr-black-to-text);
        color: #000;
        border: none;
        border-radius: unset;
        display: grid;
        place-content: center;

        svg {
          width: 18px;
          fill: var(--clr-white-to-black);
        }
      }
      .react-autosuggest__container {
        z-index: 999;
      }
      .react-autosuggest__suggestion {
        text-align: center;
        padding: 8px;
        border-bottom: 1px solid grey;
        div {
          border: none;
        }
      }
    }
    .menu {
      & > li {
        padding: 0px 15px;
      }
    }
    #brand {
      justify-content: center;
      align-items: center;
      height: 40px;
      max-width: 56px;

      img {
        max-height: 70px;
      }
    }
    .icons-container-sm {
      display: flex !important;
      justify-content: flex-end !important;
    }
    .switches li {
      padding: 10px 20px 10px 20px;
    }
    .switches span {
      animation-delay: 0.8s;
    }
  }
`

export const Category = styled.ul`
  text-transform: capitalize;
  padding: 30px 0px 0px 0px;
  list-style: none;
  li {
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0.25px;
    line-height: 22px;
    padding: 0 0 20px 0;
    cursor: pointer;
  }
  a:focus,
  a:hover {
    color: unset;
  }
  @media (max-width: 991px) {
    margin-left: 50px;
    padding: 0px;
    li {
      padding: 20px 0;
    }
  }
`
export const CategoryTitle = styled.div`
  display: flex;
  flex-direction: column;
  h3 {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.25px;
    line-height: 20px;
    padding-top: 10px;
    margin-bottom: 0;
    font-weight: 700;
    color: #5d5d5d;
  }
`

/* eslint-disable max-len */
export const NavigationV3 = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@400;600;700;900&family=Lato:wght@300;400;500;700;900&display=swap');
  --bodyFont: 'Lato', sans-serif;
  height: 116px;
  max-width: 1240px;
  margin: 0 auto;
  position: relative;
  justify-content: center;
  text-decoration: none;
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-template-rows: repeat(2, var(--header-height));

  .navbar-default .navbar-nav > .open > a,
  .navbar-default .navbar-nav > .open > a:focus,
  .navbar-default .navbar-nav > .open > a:hover,
  .nav .open > a,
  .nav .open > a:focus,
  .nav .open > a:hover {
    background: none;
  }
  .blue {
    /* Change color to var(--clr-tf-main) on svg */
    filter: invert(12%) sepia(98%) saturate(4777%) hue-rotate(238deg)
      brightness(66%) contrast(123%);
  }
  .column {
    flex-direction: column;
  }
  .hidden {
    display: none;
  }

  .upper-navbar {
    margin-bottom: 0;
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    display: flex;
    align-items: flex-start;

    .navbar-nav > li > a {
      font-size: 14px;
      color: var(--clr-tf-main);
      font-weight: 700;
      letter-spacing: 0.75px;
      line-height: 24px;
      padding: 0;
    }
    .container {
      display: flex;
      justify-content: flex-end;
      list-style: none;
      padding: 15px 20px 0 0;
      li:not(:last-child) {
        margin-right: 25px;
      }
      li a {
        font-size: 12px;
        color: var(--clr-tf-main);
        text-transform: none;
        letter-spacing: 0.25px;
        line-height: 18px;
      }
    }
  }
  .lower-navbar {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    display: flex;
    align-items: center;
    .navbar-nav {
      width: 100%;
      display: flex;
    }
    &:before,
    .container:before,
    .container:after,
    .navbar-nav:before,
    .navbar-nav:after,
    .navbar-collapse:before,
    .navbar-collapse:after {
      content: none;
    }
    .navbar-nav > li > a {
      --bodyFont: 'Josefin Sans', sans-serif;
      font-size: 14px;
      color: var(--clr-tf-main);
      font-weight: 700;
      letter-spacing: 0.75px;
      text-transform: capitalize;
      line-height: 24px;
      padding: 0;
    }
    & > .open > .dropdown-toggle {
      background-color: none;
    }
    .open > .dropdown-toggle > div {
      background-color: var(--clr-tf-main);
      color: var(--white);
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;

      img {
        transform: rotate(180deg);
        filter: brightness(0) invert(1);
        transition: all 0.3s ease;
      }
    }
  }
  .container {
    width: 100%;
    padding: 0;
  }
  .navbar {
    border-radius: 0px;
    position: unset;
    margin: 0;
  }
  .navbar-default {
    border: none;
    background-color: unset;
  }
  .navbar-collapse {
    padding: 0;
  }
  .dropdown {
    position: unset;

    &:hover {
      text-decoration: underline;
    }
  }
  .dropdown-menu {
    z-index: 1000;
    padding: ${props => (props.icons === `true` ? `30px 123px` : `50px 88px`)};
  }
  .icons {
    margin-right: 84px;
    margin-left: 45px;
  }

  .title {
    flex: 1;
    color: var(--clr-tf-main);
    max-width: 220px;
    p {
      font-size: 34px;
      font-weight: 700;
      letter-spacing: -0.5px;
      padding-bottom: 30px;
    }
  }
  #brand {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    display: flex;
    justify-content: flex-end;
    padding: 15px 45px 16px 20px;
    cursor: pointer;
  }
  .open > .dropdown-menu {
    width: 100%;
    min-height: 446px;

    .menu {
      flex: 3;
      align-items: flex-start;
      display: flex !important;
      flex-wrap: wrap;
    }
    .animated {
      animation-duration: 1s;
      animation-fill-mode: both;
    }
  }
  @media (max-width: 991px) {
    display: unset !important;

    .lower-navbar .navbar-nav > li > a:after {
      height: 0;
    }
    .navbar-header {
      height: var(--header-height);
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 0;
      align-items: center;
    }
    .navbar-default {
      margin-right: 0;
    }
    .navbar-header > * {
      flex: 1;
    }
    .navbar-left,
    .navbar-right {
      float: none !important;
    }
    .navbar-toggle {
      display: block;
      border: none;
    }
    .navbar-collapse {
      background-color: var(--white);
      border-top: 1px solid transparent;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }
    .navbar-fixed-top {
      top: 0;
      border-width: 0 0 1px;
    }
    .navbar-collapse.collapse {
      display: none !important;
    }
    .navbar-default .navbar-toggle:focus,
    .navbar-default .navbar-toggle:hover {
      background-color: transparent;
    }
    .navbar-nav {
      margin: 0;
      float: none !important;
    }
    .navbar-nav > li {
      float: none;
      position: relative;
    }
    .navbar-nav > li > a {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .collapse.in {
      display: block !important;
    }
    .container > .navbar-collapse {
      margin: 0;
    }
    .navbar-default .navbar-toggle .icon-bar {
      background-color: var(--clr-tf-main);
    }
    .open > .dropdown-menu .menu,
    .lower-navbar .navbar-nav {
      display: unset;
    }
    .open > .dropdown-menu {
      display: flex;
      align-items: center;
      min-height: unset;
    }
    .open > .dropdown-toggle img {
      transform: rotate(180deg);
      filter: brightness(0) invert(1);
    }
    .lower-navbar .open > .dropdown-toggle > div {
      background-color: var(--clr-tf-main);
      color: var(--white);
    }
    .navbar-default .navbar-nav > .open > a:link,
    .navbar-default .navbar-nav > .open > a:visited,
    .navbar-default .navbar-nav > .open > a:hover,
    .navbar-default .navbar-nav > .open > a:active {
      color: transparent;
    }
    .text {
      padding: 20px 20px 20px 1rem;
    }
    .title p {
      font-size: 12px;
      font-weight: 700;
      padding: 0;
      margin: 0;
      letter-spacing: 0.25px;
      line-height: 20px;
      text-align: center;
    }
    .icons {
      margin: 0 auto 50px auto;
    }
    .icons p {
      font-size: 16px;
      padding: 10px 0 20px 0;
    }
    .dropdown {
      background-color: var(--white);
      margin: 0 0 0 1rem;
      padding: 0;
      margin-left: 0;
      margin-right: 0;
      a {
        margin-left: 0;
      }

      &:hover {
        text-decoration: none;
      }
    }
    .dropdown-menu {
      padding: 20px 20px 40px;
    }
    .small-text {
      font-size: 11px;
      text-transform: none;
    }
    .border {
      border-bottom: 1px solid #e3e9ef;
    }
    .search {
      form {
        width: 100%;
      }
      .input-group {
        display: flex;
        width: 100%;
        position: relative;
        margin-top: 0;
        margin-bottom: 0;
        background: #f5f9fc;
        width: 100%;
        padding: 15px 22px 14px 42px;

        input {
          padding: 0;
          height: unset;
          background: #f5f9fc;
        }
      }
      .form-control {
        border: none;
      }
      .input-group-addon {
        border: none;
        padding: 0;
        background: #f5f9fc;

        svg {
          fill: var(--clr-tf-main);
        }
      }
      .react-autosuggest__container {
        z-index: 999;
      }
      .react-autosuggest__suggestion {
        text-align: center;
        padding: 8px;
        border-bottom: 1px solid grey;
        div {
          border: none;
        }
      }
    }
    .menu {
      width: 100%;
      display: flex;
      flex-direction: column;
      position: relative;

      .shop-category {
        padding: 15px 15px 40px 0px;
        margin-left: 3rem;
        display: flex;
        border-bottom: 1px solid var(--grey-7);
        width: 100%;
      }
      .category {
        padding: 0;
        margin-left: 60px;
        align-self: center;

        a {
          padding: 0;
          width: unset;
        }
        .text {
          font-weight: 400;
        }
      }
      .category-name {
        position: absolute;
        top: 15px;
        left: 30px;
        font-weight: 600;
      }
    }
    .refill {
      display: none;
    }
    #brand {
      justify-content: center;
      align-items: center;
      img {
        height: 40px;
      }
    }
    .icons-container-sm {
      display: flex !important;
      justify-content: flex-end !important;
    }
    .switches {
      padding: 20px 22px 40px 42px;
      background: #f5f9fc;

      li a {
        display: flex;
        img {
          padding-right: 10px;
        }
      }

      li + li {
        padding-top: 10px;
      }
    }
  }
  @media (max-width: 330px) {
    .menu {
      .category-name {
        position: unset;
      }
    }
  }
`
NavigationV3.propTypes = { icons: PropTypes.bool }

export const Tab = styled.div`
  display: flex;
  padding: 16px 22px 16px 42px;
  color: var(--clr-tf-main);
  font-size: 20px;
  font-weight: 700;

  &:hover {
    background-color: #e3e9ef;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  @media (max-width: 991px) {
    margin: 0;
    justify-content: space-between;

    &:hover {
      background-color: transparent;
      border-radius: 0px;
    }
  }
`
export const Links = styled.div`
  padding: 0 15px 5px 0;
  margin-left: auto;
  display: flex;
  align-items: center;

  li:not(:last-child) {
    margin-right: 20px;
  }
  .text-link {
    font-size: 16px;
    color: var(--clr-tf-main);
    text-transform: none;
    letter-spacing: 0.25px;
    line-height: 18px;
    font-weight: 900;
  }
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
    padding: 0;

    .text-link {
      width: 100%;
      font-size: 14px;
      padding: 18px 22px 18px 42px;
      border-top: 1px solid #e3e9ef;
      border-bottom: 1px solid #e3e9ef;
    }
    .text-link + .text-link {
      border-top: none;
    }
  }
`
export const FlexDirection = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 991px) {
    flex-direction: column;
  }
`
export const NavigationV4 = styled.div`
  --bodyFont: 'Verizon-NHG-eDS', sans-serif;
  --smallText: var(--sm);
  height: 116px;
  max-width: 1240px;
  margin: 0 auto;
  position: relative;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-template-rows: repeat(2, var(--header-height));
  .navbar-default .navbar-nav > .open > a,
  .navbar-default .navbar-nav > .open > a:focus,
  .navbar-default .navbar-nav > .open > a:hover,
  .nav .open > a,
  .nav .open > a:focus,
  .nav .open > a:hover {
    background: none;
  }
  .blue {
    /* Change color to var(--clr-tf-main) on svg */
    filter: invert(12%) sepia(98%) saturate(4777%) hue-rotate(238deg)
      brightness(66%) contrast(123%);
  }
  .column {
    flex-direction: column;
  }
  .hidden {
    display: none;
  }
  .expand-more {
    display: none;
  }
  .upper-navbar {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    display: flex;
    align-items: flex-start;
    .navbar-nav > li > a {
      font-size: 14px;
      color: var(--dark);
      font-weight: 700;
      letter-spacing: 0.75px;
      line-height: 24px;
      padding: 0;
    }
    .container {
      display: flex;
      justify-content: flex-end;
      list-style: none;
      padding: 15px 20px 0 0;
      li:not(:last-child) {
        margin-right: 25px;
      }
      li a {
        font-size: 12px;
        color: var(--dark);
        text-transform: none;
        letter-spacing: 0.25px;
        line-height: 18px;
      }
    }
  }
  .lower-navbar {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    display: flex;
    align-items: center;
    .navbar-nav {
      width: 100%;
      display: flex;
    }
    &:before,
    .container:before,
    .container:after,
    .navbar-nav:before,
    .navbar-nav:after,
    .navbar-collapse:before,
    .navbar-collapse:after {
      content: none;
    }
    .navbar-nav > li > a {
      --bodyFont: 'Verizon-NHG-eDS', sans-serif;
      font-size: 14px;
      color: var(--dark);
      font-weight: 700;
      letter-spacing: 0.75px;
      text-transform: capitalize;
      line-height: 24px;
      padding: 0;
    }
    & > .open > .dropdown-toggle {
      background-color: none;
    }
    .open > .dropdown-toggle > div {
      .chevron-container {
        display: flex;
        justify-content: center;
      }
      .chevron {
        position: relative;
        transform: scale(var(--ggs, 1));
        width: 22px;
        height: 17px;
        border-left: 2px solid transparent;
        border-bottom: 3px solid #f8f8f8;
        z-index: 1001;
      }
      .chevron,
      .chevron::before {
        display: block;
        box-sizing: border-box;
        border-right: 2px solid transparent;
      }
      .chevron::before {
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        border-left: 2px solid rgba(0, 0, 0, 0.15);
        border-top: 2px solid rgba(0, 0, 0, 0.15);
        border-bottom: 3px solid #f8f8f8;
        transform: rotate(45deg) skew(10deg, 10deg);
        left: -2px;
        bottom: -12px;
      }
    }
    .open > .dropdown-toggle > div > div {
      color: #e00;
      img {
        transform: rotate(180deg);
        filter: brightness(0) invert(1);
        transition: all 0.3s ease;
      }
    }
    .navbar-nav {
     .dropdown-menu {
         left: var(--left);
     }
    }
     li:nth-child(3) {
       --left: -110%;
     }
     li:nth-child(4) {
       --left: -20%;
     }
     li:nth-child(5) {
       --left: -100%;
     }
    }
  .container {
    width: 100%;
    padding: 0;
  }
  .navbar {
    border-radius: 0px;
    position: unset;
    margin: 0;
  }
  .navbar-default {
    border: none;
    background-color: unset;
  }
  .navbar-collapse {
    padding: 0;
  }
  .dropdown {
    &.open {
      &.full {
        position: unset;
        .dropdown-menu {
          margin-top: 0;
          padding: 30px 10px;
          left: 0;
        }
      }
      .dropdown-menu {
        padding: 30px;
        margin-top: -3px;
      }
    }
  }
  .dropdown-menu {
    z-index: 1000;
    background-color: #f8f8f8;
  }
  .icons {
    margin-right: 84px;
    margin-left: 45px;
  }
  .title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: -0.5px;
    text-align: center;
    line-height: 20px;
  }
  #brand {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    display: flex;
    justify-content: flex-end;
    padding: 15px 45px 16px 20px;
    cursor: pointer;
  }
  .full.open > .dropdown-menu {
    width: 100%;
    min-height: 446px;
    .menu {
      align-items: stretch;
      justify-content: space-around;
      display: flex !important;
    }
    .animated {
      animation-duration: 1s;
      animation-fill-mode: both;
    }
  }
  @media (max-width: 991px) {
    display: unset !important;
    .expand-more {
      display: block;
      margin-right: 15px;
    }
    .nav-title {
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-items: center;
    }
    .dropdown.open.full,
    .dropdown.open {
      position: relative;
      .dropdown-menu {
        width: 100%;
      }
    }
    .chevron-container {
      display: none;
    }
    .chevron {
      display: none;
    }
    .text-title {
      margin-left: 40px;
    }
    .lower-navbar .navbar-nav > li > a:after {
      height: 0;
      margin-left: 40px;
    }
    .navbar-header {
      height: var(--header-height);
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 0;
      align-items: center;
    }
    .navbar-default {
      margin-right: 0;
    }
    .navbar-header > * {
      flex: 1;
    }
    .navbar-left,
    .navbar-right {
      float: none !important;
    }
    .navbar-toggle {
      display: block;
      border: none;
    }
    .navbar-collapse {
      background-color: var(--white);
      border-top: 1px solid transparent;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }
    .navbar-fixed-top {
      top: 0;
      border-width: 0 0 1px;
    }
    .navbar-collapse.collapse {
      display: none !important;
    }
    .navbar-default .navbar-toggle:focus,
    .navbar-default .navbar-toggle:hover {
      background-color: transparent;
    }
    .navbar-nav {
      margin: 0;
      float: none !important;
    }
    .navbar-nav > li {
      float: none;
      position: relative;
    }
    .navbar-nav > li > a {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .collapse.in {
      display: block !important;
    }
    .container > .navbar-collapse {
      margin: 0;
    }
    .navbar-default .navbar-toggle .icon-bar {
      background-color: 'var(--dark)';
    }
    .open > .dropdown-menu .menu,
    .lower-navbar .navbar-nav {
      display: unset;
    }
    .open > .dropdown-menu {
      display: flex;
      align-items: center;
      min-height: unset;
    }
    .open > .dropdown-toggle img {
      transform: rotate(180deg);
      filter: brightness(0) invert(1);
    }
    .lower-navbar .open > .dropdown-toggle > div {
      background-color: red;
      color: #fff;
      .text-title {
        color: #fff;
      }
      .chevron-container {
        display: none;
      }
      .chevron {
        display: none;
      }
    }
    .navbar-default .navbar-nav > .open > a:link,
    .navbar-default .navbar-nav > .open > a:visited,
    .navbar-default .navbar-nav > .open > a:hover,
    .navbar-default .navbar-nav > .open > a:active {
      color: transparent;
    }
    .text {
      padding: 20px 20px 20px 1rem;
    }
    .title p {
      font-size: 12px;
      font-weight: 700;
      padding: 0;
      margin: 0;
      letter-spacing: 0.25px;
      line-height: 20px;
      text-align: center;
    }
    .icons {
      margin: 0 auto 50px auto;
    }
    .icons p {
      font-size: 16px;
      padding: 10px 0 20px 0;
    }
    .dropdown {
      background-color: var(--white);
      margin: 0 0 0 1rem;
      padding: 0;
      margin-left: 0;
      margin-right: 0;
      a {
        margin-left: 0;
      }
      &:hover {
        text-decoration: none;
      }
    }
    .dropdown-menu {
      padding: 20px 20px 40px;
    }
    .small-text {
      font-size: 11px;
      text-transform: none;
      color: var(--dark);
    }
    .border {
      border-bottom: 1px solid #e3e9ef;
    }
    .search {
      form {
        width: 100%;
      }
      .input-group {
        display: flex;
        width: 100%;
        position: relative;
        margin-top: 0;
        margin-bottom: 0;
        background: #f5f9fc;
        width: 100%;
        padding: 15px 22px 14px 42px;
        input {
          padding: 0;
          height: unset;
          background: #f5f9fc;
        }
      }
      .form-control {
        border: none;
      }
      .input-group-addon {
        border: none;
        padding: 0;
        background: #f5f9fc;
        svg {
          fill: var(--clr-tf-main);
        }
      }
      .react-autosuggest__container {
        z-index: 999;
      }
      .react-autosuggest__suggestion {
        text-align: center;
        padding: 8px;
        border-bottom: 1px solid grey;
        div {
          border: none;
        }
      }
    }
    .menu {
      width: 110%;
      display: flex;
      flex-direction: column;
      position: relative;
      .shop-category {
        padding: 15px 15px 40px 0px;
        margin-left: 3rem;
        display: flex;
        border-bottom: 1px solid var(--grey-7);
        width: 100%;
      }
      .category {
        padding: 0;
        margin-left: 60px;
        align-self: center;
        a {
          padding: 0;
          width: unset;
        }
        .text {
          font-weight: 400;
        }
      }
      .category-name {
        position: absolute;
        top: 15px;
        left: 30px;
        font-weight: 600;
      }
    }
    .refill {
      display: none;
    }
    #brand {
      justify-content: center;
      align-items: center;
      img {
        height: 25px;
      }
    }
    .icons-container-sm {
      display: flex !important;
      justify-content: flex-end !important;
    }
    .switches {
      padding: 20px 22px 40px 42px;
      background: #f5f9fc;
      li a {
        display: flex;
        img {
          padding-right: 10px;
        }
      }
      li + li {
        padding-top: 10px;
      }
    }
  }
  @media (max-width: 330px) {
    .menu {
      .category-name {
        position: unset;
      }
    }
  }
`

export const TabV4 = styled.div`
  display: flex;
  padding: 0 15px 20px 0;
  color: var(--dark);

  &:hover {
    color: var(--grey-1);
  }

  @media (max-width: 991px) {
    margin: 0;
    justify-content: space-between;
    align-items: center;

    .text-title {
      align-self: center;
      margin-top: 20px;
    }

    &:hover {
      color: var(--grey-1);
    }
  }
`
export const LinksV4 = styled.div`
  padding: 0 15px 15px 0;
  margin-left: auto;
  display: flex;
  align-items: center;

  li:not(:last-child) {
    margin-right: 20px;
  }
  .text-link {
    font-size: 14px;
    color: var(--dark);
    text-transform: none;
    letter-spacing: 0.25px;
    line-height: 18px;
    font-weight: 900;
  }
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
    padding: 0;

    .text-link {
      width: 100%;
      font-size: 14px;
      padding: 18px 22px 18px 42px;
      border-top: 1px solid #e3e9ef;
      border-bottom: 1px solid #e3e9ef;
    }
    .text-link + .text-link {
      border-top: none;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Navbar/styled.js